import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgSettings = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.168 18.5a6.685 6.685 0 01-1.467-.61 1.955 1.955 0 00-2.59-2.59 6.697 6.697 0 01-.61-1.468A1.954 1.954 0 005.5 10.17a6.7 6.7 0 01.613-1.47A1.956 1.956 0 008.7 6.112a6.674 6.674 0 011.467-.611 1.954 1.954 0 003.664 0 6.702 6.702 0 011.468.61 1.955 1.955 0 002.59 2.59c.262.466.467.959.61 1.47a1.956 1.956 0 000 3.662 6.686 6.686 0 01-.61 1.468A1.955 1.955 0 0015.3 17.89a6.725 6.725 0 01-1.47.611 1.954 1.954 0 00-3.663 0zm3.171 1.411a.466.466 0 00.375.08 8.071 8.071 0 002.721-1.132.466.466 0 00.111-.689 1.156 1.156 0 01.08-1.544 1.156 1.156 0 011.543-.079.472.472 0 00.69-.111 8.084 8.084 0 001.13-2.72.47.47 0 00-.41-.566 1.156 1.156 0 01-1.04-1.148c0-.59.447-1.084 1.04-1.147a.473.473 0 00.41-.566 8.092 8.092 0 00-1.13-2.724.471.471 0 00-.69-.11 1.155 1.155 0 01-1.544-.078 1.156 1.156 0 01-.079-1.545.47.47 0 00-.111-.69 8.083 8.083 0 00-2.72-1.13.47.47 0 00-.567.41A1.156 1.156 0 0112 5.462a1.156 1.156 0 01-1.147-1.04.47.47 0 00-.567-.41 8.093 8.093 0 00-2.722 1.13.47.47 0 00-.11.69c.372.463.34 1.128-.078 1.545-.417.417-1.08.45-1.544.078a.472.472 0 00-.69.11 8.09 8.09 0 00-1.131 2.724.47.47 0 00.41.566 1.154 1.154 0 011.039 1.147c0 .592-.446 1.085-1.04 1.148a.472.472 0 00-.409.566 8.1 8.1 0 001.13 2.72.472.472 0 00.692.11 1.154 1.154 0 011.545.077c.418.418.45 1.083.076 1.546a.47.47 0 00.111.69c.84.545 1.756.925 2.721 1.131a.47.47 0 00.567-.41A1.156 1.156 0 0112 18.54c.591 0 1.084.447 1.148 1.04a.47.47 0 00.191.331zM10.25 12c0-.965.785-1.75 1.75-1.75s1.75.785 1.75 1.75-.785 1.75-1.75 1.75-1.75-.785-1.75-1.75zM9 12c0 1.655 1.346 3 3 3s3-1.345 3-3-1.346-3-3-3-3 1.345-3 3z"
      clipRule="evenodd"
    />
  </svg>
));
SvgSettings.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgSettings;
